export const DATA_LOGIN = {
    username: "ws_fil_usr",
    password: "WSF1lPWD!",
  }